import * as React from "react"
import { Container, Row } from "./library/container"

export const SearchBarWrapper: React.StatelessComponent<{}> = props => {
  return (
    <section className="search-bar cf">
      <Container>
        <div className="search-bar__wrapper">{props.children}</div>
      </Container>
    </section>
  )
}
